/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { containerStyles } from "../../theme/commonStyle";
import { Theme } from "@mui/material";

const containerFullWidthStyle = {
  sectionContainer: {
    paddingTop: containerStyles.paddingTop,
    paddingBottom: containerStyles.paddingBottom,
  },
  grey: {
    backgroundColor: "background.contrast",
  },
  primary: {
    backgroundColor: "background.default",
  },
  innerSectionContainer: (theme: Theme) => ({
    paddingLeft: containerStyles.paddingLeft,
    paddingRight: containerStyles.paddingRight,
    margin: containerStyles.margin,
    width: containerStyles.width,
    [theme.breakpoints.up("lg")]: {
      maxWidth: "1140px",
    },
    "& h2": {
      marginTop: 0,
    },
  }),
  section: {},
  noSection: {
    paddingTop: 0,
    paddingBottom: 0,
  },
};

export default containerFullWidthStyle;
